"use strict";

exports.__esModule = true;
var _SettingsMenu = require("./SettingsMenu");
Object.keys(_SettingsMenu).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _SettingsMenu[key]) return;
  exports[key] = _SettingsMenu[key];
});